import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { localize, updateLanguage } from 'react-localize-redux';

import FlatButton from 'material-ui/FlatButton';
import TextField from '@material-ui/core/TextField';
import { MdHighlightOff as HighlightOffIcon } from 'react-icons/md';
import { BounceLoader } from 'halogenium';
import { colors } from 'helpers/ColorHelper';
import { startsWith } from 'helpers/StringHelper';

import Auth from 'j-toker';

import { connect } from 'react-redux';

import * as notificationsActions from 'actions/notificationActions';

import { AccentColor } from 'helpers/AccentColorHelper';

import {
  passwordConfirmationValidation,
  passwordValidation,
  passwordValidationWeak,
} from 'helpers/PasswordHelper';

const style = {
  text_field_margin: {
    marginTop: '15px',
  },
  button: {
    marginTop: '20px',
    color: 'white',
  },
  header: {
    paddingTop: '10px',
    maxWidth: '400px',
    margin: '10px auto',
    textAlign: 'center',
  },
};
export default connect(
  store => ({
    userType: store.userTypes.loginAuth,
    passwordRedirectURL: store.userTypes.passwordRedirectURL,
  }),
  { ...notificationsActions, updateLanguage }
)(
  localize()(
    class ChangePasswordReset extends Component {
      state = {
        password: '',
        password_confirmation: '',
        updatingPassword: false,
        finishedEditingPassword: false,
        showErrorsOnFormMessage: false,
      };

      componentDidMount() {
        const query = browserHistory.getCurrentLocation().query;
        const locale = query && query.locale;
        if (locale) {
          this.props.updateLanguage(locale);
          localStorage.setItem('locale', locale);
          this.forceUpdate();
        }
      }

      isMaintenance = () => {
        return startsWith(browserHistory.getCurrentLocation().pathname, '/maintenance');
      };

      handlePasswordOnBlur = _event => {
        this.setState({ finishedEditingPassword: true, showErrorsOnFormMessage: false });
      };

      handleInputChange = event => {
        this.setState({
          [event.target.name]: event.target.value.trim(),
          finishedEditingPassword: false,
          showErrorsOnFormMessage: false,
        });
      };

      validatePassword = () => {
        if (this.isMaintenance()) {
          return passwordValidationWeak(this.state.password);
        }

        return passwordValidation(this.state.password);
      };

      updatePassword = () => {
        if (
          !passwordConfirmationValidation(this.state.password, this.state.password_confirmation) ||
          !this.validatePassword()
        ) {
          this.setState({ showErrorsOnFormMessage: true });
          return null;
        }

        this.setState({ updatingPassword: true });
        const auth = Auth;
        Auth.updatePassword({
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
          config: this.props.config,
        })
          .then(_response => {
            auth.configDfd = null;
            this.props.showSuccess(this.props.translate('success.passwordUpdated'));
            browserHistory.push(`${this.props.passwordRedirectURL}`);
          })
          .catch(error => {
            auth.configDfd = null;
            this.setState({ updatingPassword: false });
            if (error.data.errors) {
              this.props.showFailure(error.data.errors.full_messages[0], true);
            } else {
              this.props.showFailure(this.props.translate('unknownError'), true);
            }
            console.error(error);
          });
      };

      render() {
        if (this.state.updatingPassword) return this.renderLoading();
        return this.renderPasswordResetForm();
      }

      renderPasswordResetForm = () => {
        return (
          <div className="body" role="main">
            <div className="centers">
              <div style={{ height: '100%', padding: 0 }}>
                <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
                  <div style={style.header}>
                    <div style={{ textAlign: 'center' }}>
                      <span className="page-title">
                        {this.props.translate('settings.changePassword')}
                      </span>
                    </div>
                    <div className="row">
                      <TextField
                        name="password"
                        type="password"
                        label={this.props.translate('password')}
                        inputProps={{ 'aria-label': this.props.translate('password') }}
                        onChange={this.handleInputChange}
                        onBlur={this.handlePasswordOnBlur}
                        style={style.text_field_margin}
                        value={this.state.password}
                        variant="outlined"
                      />
                      <div className="row">
                        <div className="col-sm-10 col-sm-offset-1">
                          {this._renderPasswordStrengthValidation()}
                        </div>
                      </div>
                      <TextField
                        name="password_confirmation"
                        type="password"
                        label={this.props.translate('repeatPassword')}
                        inputProps={{ 'aria-label': this.props.translate('repeatPassword') }}
                        onChange={this.handleInputChange}
                        style={style.text_field_margin}
                        value={this.state.password_confirmation}
                        variant="outlined"
                      />
                      <div className="row">
                        <div className="col-sm-10 col-sm-offset-1">
                          {this.renderConfirmationPasswordValidation()}
                        </div>
                      </div>
                    </div>

                    {this._renderErrorsOnFormMessage()}

                    <div className="row">
                      <FlatButton
                        label={this.props.translate('update')}
                        primary={true}
                        onClick={this.updatePassword}
                        backgroundColor={AccentColor()}
                        hoverColor="grey"
                        style={style.button}
                      />
                    </div>
                    {this._renderReturnToPortal()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };

      _renderReturnToPortal = () => {
        const notTenantPortal = !startsWith(
          browserHistory.getCurrentLocation().pathname,
          '/tenant_change_password_reset'
        );
        if (notTenantPortal) return;

        const query = browserHistory.getCurrentLocation().query;
        if (query.reset_password_email === 'true') return;

        return (
          <div className="row" style={{ marginTop: '3px' }}>
            <button
              type="button"
              className="link-button"
              onClick={() => browserHistory.push('/dashboard')}
            >
              {this.props.translate('returnToPortal')}
            </button>
          </div>
        );
      };

      renderLoading = () => {
        return (
          <div className="body" role="main">
            <div className="centers">
              <div className="row" style={{ marginTop: '50px' }}>
                <div
                  style={{
                    textAlign: 'center',
                    width: '60px',
                    margin: 'auto',
                  }}
                >
                  <BounceLoader color={AccentColor()} />
                </div>
                <p style={{ textAlign: 'center' }}>{this.props.translate('updatingPassword')}</p>
              </div>
            </div>
          </div>
        );
      };

      _renderPasswordStrengthValidation = () => {
        const { finishedEditingPassword } = this.state;
        if (!finishedEditingPassword) return;
        if (this.validatePassword()) return;

        return (
          <div className="row">
            <div className="col-xs-2">
              <HighlightOffIcon style={{ padding: 0, textAlign: 'center', color: colors.RED }} />
            </div>
            <div className="col-xs-10">
              <p style={{ color: colors.RED, fontSize: '14px', textAlign: 'left' }}>
                {this.isMaintenance()
                  ? this.props.translate('passwordLengthWeak')
                  : this.props.translate('passwordStrength')}
              </p>
            </div>
          </div>
        );
      };

      renderConfirmationPasswordValidation = () => {
        const { password, password_confirmation } = this.state;
        if (password === '' || password_confirmation === '') return false;
        if (passwordConfirmationValidation(password, password_confirmation)) return false;

        return (
          <div className="row">
            <div className="col-xs-2">
              <HighlightOffIcon style={{ padding: 0, textAlign: 'center', color: colors.RED }} />
            </div>
            <div className="col-xs-10">
              <p style={{ color: colors.RED, fontSize: '12px', textAlign: 'left' }}>
                {this.props.translate('passwordsMustMatch')}
              </p>
            </div>
          </div>
        );
      };

      _renderErrorsOnFormMessage = () => {
        const { showErrorsOnFormMessage } = this.state;
        if (!showErrorsOnFormMessage) return;

        return (
          <div className="row">
            <div className="col-xs-2">
              <HighlightOffIcon style={{ padding: 0, textAlign: 'center', color: colors.RED }} />
            </div>
            <div className="col-xs-10">
              <p style={{ color: colors.RED, fontSize: '12px', textAlign: 'left' }}>
                {this.props.translate('passwordErrorsOnForm')}
              </p>
            </div>
          </div>
        );
      };
    }
  )
);
